import {
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  SimpleGrid,
} from "@chakra-ui/react";
import { Field } from "react-final-form";

const RadioField = ({
  id,
  labelPlacement,
  label,
  placeholder,
  isRequired,
  choices,
}) => {
  return (
    <FormControl>
      {labelPlacement !== "HIDDEN" && (
        <FormLabel
          fontWeight="normal"
          sx={{
            span: {
              fontWeight: "normal!important",
            },
          }}
        >
          {label}
        </FormLabel>
      )}
      <RadioGroup>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={3}>
          {choices.map(({ text, value }, i) => (
            <Field name={`id_${id}`} type="checkbox" value={value} key={i}>
              {({ input }) => (
                <Radio
                  {...input}
                  key={i}
                  sx={
                    {
                      // ".chakra-checkbox__control": {
                      //   bg: "white",
                      // },
                    }
                  }
                >
                  {text}
                </Radio>
              )}
            </Field>
          ))}
        </SimpleGrid>
      </RadioGroup>
    </FormControl>
  );
};

export default RadioField;
